import type { ReactNode } from 'react';

export const symbol_nest_display_max: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M501.5-578.68q8.5-8.67 8.5-21.5 0-12.82-8.68-21.32-8.67-8.5-21.5-8.5-12.82 0-21.32 8.68-8.5 8.67-8.5 21.5 0 12.82 8.68 21.32 8.67 8.5 21.5 8.5 12.82 0 21.32-8.68ZM480-200q-99 0-169.5-13.5T240-246v-34h-95q-26.14 0-44.07-19.5T85-345l31-360q2-23 18.81-39T175-760h610q23.38 0 40.19 16T844-705l31 360q2 26-15.93 45.5T815-280h-95v34q0 19-70.5 32.5T480-200ZM145-340h670l-30-360H175l-30 360Zm335-180Z"
		/>
	</svg>
);
